import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomTrim = createSvgIcon(
  <path d="M17.36 18.15h-3.49l-.87-.92.29-.29h4.07zm-.28 2.066a1.66 1.66 0 0 1 .86-.736v-7.19l.29-.29.88.87v4.07h1.37a1.66 1.66 0 1 1 0 1.17h-1.37v1.37a1.66 1.66 0 1 1-2.03.735m1.65-2.689a.2.2 0 0 0-.06-.107v-.04a.21.21 0 0 0-.29.04.21.21 0 1 0 .35.107M8.56 7.5l6 4.01-6 4zm-6 3.5h-2v6.5a2 2 0 0 0 2 2h9v-2h-9zm18-5.5v5h2v-5a2 2 0 0 0-2-2H8v2zm-15.75 0-.22-.09-.86-1.91L3.5 3l-.23.5-.86 1.91-1.85.84L0 6.5l.56.25.54.25 1.31.59.15.34L3.5 10 4 8.9l.59-1.31L5.9 7 7 6.5z" />,
  'CustomTrim',
);

export default CustomTrim;
